import React from "react";
import { IconButton } from "@mui/material";
import { Info, InfoOutlined } from "@mui/icons-material";
import { CustomText } from "../../../components";
import { fonts } from "../../../config";
import { StylesForm } from "../styles";
import { masks } from "../../../utils";
import { customModal } from "../../../components/modals/utils";
import { Styles as ModalStyles } from "../../../components/modals/styles";

interface Step {
  title: string;
  description: string;
}

interface StepHeaderProps {
  steps: Step[];
  currentStep: number;
  dataAp?: any
}

function StepHeader({ steps, currentStep, dataAp }: StepHeaderProps) {
  const handleOpenFacialTips = () => {
    customModal.setInfos(
      "Dicas para uma boa foto",
      [],
      { label: "Ok, entendi", onClick: () => customModal.close() },
      null,
      <ModalStyles.ExtraFieldContainer>
        <p style={{ margin: 0, marginBottom: "8px", }}>
          Ao tirar sua foto ou escolher de sua galeria, não esqueça de seguir nossas dicas para uma boa identificação:
        </p>
        <ul style={{ paddingLeft: "20px", margin: 0 }}>
          <li>Esteja em um ambiente bem iluminado;</li>
          <li>Mantenha seu rosto com uma expressão neutra;</li>
          <li>Se possível, evite cabelo ou objetos cobrindo o rosto;</li>
        </ul>
      </ModalStyles.ExtraFieldContainer>, false, true
    );
  };

  return (
    <StylesForm.HeaderSteps>
      <div
        style={{ display: "flex", alignItems: "center", marginBottom: "16px", gap: "5px" }}
      >
        {steps.map((_, index) => (
          <React.Fragment key={index}>
            <div
              style={{
                width: currentStep === index ? '40px' : "8px",
                height: "8px",
                borderRadius: "5px",
                backgroundColor: index <= currentStep ? "#0C396D" : "#D2D2D2",
                flexShrink: 0,
              }}
            />

          </React.Fragment>
        ))}
      </div>

      {/* Title and Description */}
      <CustomText
        style={{
          paddingBottom: "5px",
          "@media (max-width: 600px)": { fontSize: "13px" },
        } as React.CSSProperties}
        fontSize={2.25}
        fontFamily={fonts.bold}
        textColor="#4D585A"
      >
        {steps[currentStep]?.title}
      </CustomText>
      <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
        <CustomText
          style={{ "@media (max-width: 600px)": { fontSize: "12px" } } as React.CSSProperties}
          fontSize={1.75}
          fontFamily={fonts.regular}
          textColor="#24272A"
        >
          {steps[currentStep]?.description}
        </CustomText>
        {steps[currentStep]?.title === "Cadastro da Facial" && (
          <IconButton size="small" onClick={handleOpenFacialTips} style={{ padding: 0, color: "#0C396D" }}>
            <Info fontSize="small" />
          </IconButton>
        )}
      </div>


      {dataAp && <CustomText
        style={{ "@media (max-width: 600px)": { fontSize: "12px" } } as React.CSSProperties}
        fontSize={1.75}
        fontFamily={fonts.regular}
        textColor="#24272A"
      >
        {dataAp?.place?.name} | {" " +
          masks.formatDate(dataAp?.startDate) +
          " a " +
          masks.formatDate(dataAp?.endDate)}
      </CustomText>}
    </StylesForm.HeaderSteps>
  );
}

export default StepHeader;
